module.exports = __webpack_public_path__ + "img/club-brugge-kv-logo-icon.e2eea0be.png";